export const routes = {
  start: "/",
  statystyki: "/statystyki",
  zasady: "/zasady",
  kategoria: "/kategoria",
  oAutorze: "/o-autorze",
};
